import styled, { css } from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../styling/breakpointsMinWidth';
import CommonPlaceHolder from './placeholder';

export const ArrayItemWrapper = styled.div`
  user-select: ${(props) => props.isSafari && 'text !important'};
  -webkit-user-select: ${(props) => props.isSafari && 'text !important'};

  display: grid;
  grid-template-columns: 1fr min-content;
  grid-column-gap: 12px;
  height: 40px;
  align-items: center;
  margin: 0px 14px 8px 0;
  position: relative;
  transition: all 0.3s ease-in-out;
  transition-property: height, margin-top, opacity;
  opacity: 1;

  &:hover {
    .drag-signifier-array-item {
      opacity: 1;
      cursor: grab;
    }
  }

  @media ${breakpointsMinWidth.tabletSm} {
    height: 36px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    height: 40px;
  }

  ${(props) => {
    const { nodeType, newlyAddedItem } = props;

    if (nodeType === 'personal_link') {
      return css`
        margin: 0px 20px 8px 0;
        grid-template-columns: 17% 79% 6%;
        grid-column-gap: 8px;

        @media ${breakpointsMinWidth.mobileMicroLg} {
          grid-template-columns: 14% 82% 6%;
        }

        @media ${breakpointsMinWidth.tabletSm} {
          grid-template-columns: 30% 67% 4%;
        }

        @media ${breakpointsMinWidth.tabletLg} {
          grid-template-columns: 30% 68% 6%;
        }

        @media ${breakpointsMinWidth.desktopMd} {
          grid-template-columns: 27% 71% 4%;
        }
      `;
    }

    if (nodeType === 'skill_title') {
      return css`
        margin: 0px 10px 8px 36px;
        grid-column-gap: 10px;
        @media ${breakpointsMinWidth.mobileMicroLg} {
          grid-column-gap: 8px;
          margin: 0 12px 8px 28px;
        }

        @media ${breakpointsMinWidth.tabletSm} {
          margin: 0 10px 8px 19px;
        }

        @media ${breakpointsMinWidth.tabletLg} {
          grid-column-gap: 10px;
          margin: 0 12px 8px 19px;
        }
        @media ${breakpointsMinWidth.tabletMd} {
          margin: 0 16px 8px 24px;
        }
        @media ${breakpointsMinWidth.desktopSm} {
          grid-column-gap: 12px;
          margin: ${newlyAddedItem ? '-8px 20px 0px 39px' : '0 20px 8px 39px'};
        }

        @media ${breakpointsMinWidth.desktopMd} {
          margin: 0 24px 8px 48px;
        }

        height: ${newlyAddedItem && '0'};
        margin-bottom: ${newlyAddedItem && '0'};
        opacity: ${newlyAddedItem && '0'};
      `;
    }
    return null;
  }}
`;

export const Label = styled.label`
  text-align: start;
  margin: 12px 0 0 20px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #000000;
  visibility: ${(props) => props.isCollapseChildren && 'hidden'};
  overflow: ${(props) => props.isCollapseChildren && 'hidden'};

  @media ${breakpointsMinWidth.mobileMicroLg} {
    margin: 12px 0 0 6px;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    margin: 12px 0 0 12px;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    margin: 12px 0 0 12px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    margin: 12px 0 0 23px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    margin: 12px 0 0 28px;
    font-size: 14px;
  }
`;

const InputIsFocused = ({ isFocused }) => {
  if (isFocused) {
    return css`
      border: 1px solid #8510df;
    `;
  }

  return css``;
};

export const Input = styled.div`
  pointer-events: auto;
  cursor: text;
  height: 100%;
  position: relative;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 0 0 10px;
  display: grid;
  grid-template-columns: 1fr min-content;
  grid-column-gap: 10px;

  ${(props) => InputIsFocused(props)}

  @media ${breakpointsMinWidth.mobileMicroLg} {
    padding: 0 0px 0 15px;
    grid-column-gap: 15px;
  }
  @media ${breakpointsMinWidth.tabletSm} {
    /* height: 36px; */
    padding: 0 0px 0 8px;
    grid-column-gap: 8px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    padding: 0 0px 0 8px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 0 0px 0 11px;
    grid-column-gap: 11px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    padding: 0 0px 0 11px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    /* height: 40px; */
    padding: 0 0px 0 13px;
    grid-column-gap: 13px;
  }

  ${(props) => {
    const { nodeType } = props;

    if (nodeType === 'hobbies_and_interests' || nodeType === 'personal_link') {
      return css`
        align-items: center;
        background-color: #fff;
      `;
    }
    if (nodeType === 'publication') {
      return css`
        display: grid;
        align-items: center;
        background-color: #fff;
      `;
    }
    if (nodeType === 'skill_title' || nodeType === 'language') {
      return css`
        display: grid;
        align-items: center;
        background-color: #fff;
      `;
    }

    return null;
  }}
`;

export const Children = styled.div`
  /* width: -webkit-fill-available; */
  width: 100%;
  text-align: left;
  font-size: 12px;
  line-height: 24px;
  white-space: nowrap;
  height: inherit;
  display: flex;
  align-items: center;
  overflow: auto;
  text-align: justify;
  scrollbar-width: none;
  @supports (-moz-appearance: none) {
    width: 100%;
  }
  span {
    white-space: pre;
    word-wrap: normal;
    width: 100%;
  }
  span:not('underline_highlight') {
    width: inherit;
    white-space: pre;
    word-wrap: normal;
    @supports (-moz-appearance: none) {
      white-space: pre;
    }
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  ${(props) => {
    const { nodeType } = props;
    if (nodeType === 'skill_title') {
      return css`
        span {
          grid-column: 1/-1;
        }
      `;
    }

    return null;
  }}
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;

export const RightTools = styled.div`
  display: none;
  align-items: center;
  height: 100%;
  gap: 4px;
  right: 24px;
  padding: 0 10px 0 10px;
  margin-left: auto;
  user-select: none;
  min-width: ${(props) => props.isSafari && '100px'};

  ${Input}:hover & {
    display: flex;
    background-color: #f2f2f2
    border-radius: 0 4px 4px 0;
  }

    ${(props) => {
      const { isFocused } = props;
      if (isFocused) {
        return css`
          display: flex;
          background-color: #f2f2f2
          border-radius: 0 4px 4px 0;
        `;
      }

      return null;
    }};

    ${(props) => {
      const { nodeType, isSafari } = props;
      if (nodeType === 'publication') {
        return css`
          height: 100%;
        `;
      }
      if (nodeType === 'skill_title') {
        return css`
          min-width: ${isSafari && '100px'};
        `;
      }

      return null;
    }};
`;

export const Tools = styled.div`
  display: none;
  align-items: center;
  height: 100%;
  gap: 8px;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  user-select: none;
  opacity: 0;
  z-index: 1;

  ${Input}:hover & {
    opacity: 1;
    display: flex;
  }

  ${(props) => {
    const { isFocused } = props;
    if (isFocused) {
      return css`
        opacity: 1;
        display: flex;
      `;
    }
    return null;
  }};
`;

export const RatingWrapper = styled.span`
  opacity: 0;
  display: none;

  ${Input}:hover & {
    opacity: 1;
    display: flex;
  }

  ${(props) => {
    const { isFocused } = props;
    if (isFocused) {
      return css`
        opacity: 1;
        display: flex;
      `;
    }
    return null;
  }};
`;

export const DragWrapper = styled.div`
  pointer-events: auto;
  position: absolute;
  opacity: 0;
  z-index: 1;
  margin: 0 0 0 -20px;
  user-select: -moz-none;

  @media ${breakpointsMinWidth.tabletLg} {
    margin: 0 0 0 -23px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    margin: 0 0 0 -24px;
  }
`;

export const PlaceHolder = styled(CommonPlaceHolder)`
  padding: 0 0 0 10px;
  @media ${breakpointsMinWidth.mobileMicroLg} {
    padding: 0 0 0 15px;
  }
  @media ${breakpointsMinWidth.tabletSm} {
    padding: 0 0 0 8px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    padding: 0 0 0 8px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 0 0 0 11px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    padding: 0 0 0 11px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    padding: 0 0 0 13px;
  }
`;
